import { makeGetters, makeSetters } from '@/utils/vuex-helper';

const state = {
  dayOfWeekVisible: [],
  title: '',
  backgroundColor: '#4a4a4a',
  showPeriod: false,
  showFirstColumnTime: false,
  showCourseTime: true,
  showInstructors: true,
  invisibleParentCourses: [],
  fontSize: 100,
  subFontSize: 100,
  breakTimes: [],
  courseDates: [],
  childCoursesByDate: new Map(),
  courseStartEndTimes: []
};

const mutations = {
  ...makeSetters([
    'dayOfWeekVisible',
    'title',
    'backgroundColor',
    'showPeriod',
    'showFirstColumnTime',
    'showCourseTime',
    'showInstructors',
    'invisibleParentCourses',
    'fontSize',
    'subFontSize',
    'breakTimes',
    'courseDates',
    'childCoursesByDate',
    'courseStartEndTimes'
  ]),
  addCourseTime(_state, newTime) {
    if (!_state.courseStartEndTimes.includes(newTime)) {
      _state.courseStartEndTimes.push(newTime);
    }
  }
};

const getters = {
  ...makeGetters([
    'dayOfWeekVisible',
    'title',
    'backgroundColor',
    'showPeriod',
    'showFirstColumnTime',
    'showCourseTime',
    'showInstructors',
    'invisibleParentCourses',
    'fontSize',
    'subFontSize',
    'breakTimes',
    'courseDates',
    'childCoursesByDate',
    'courseStartEndTimes'
  ])
};

const actions = {
  async resetTimeTableInfos({ commit }) {
    commit('setTitle', '');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
